<template>
  <ItemPage
    :title="titlePage"
    size="md"
    :actions="actions"
  >
    <v-progress-linear
      v-if="loading"
      color="amber"
      indeterminate
    />
    <v-alert
      v-if="exam.is_published"
      dense
      type="info"
    >
      Esta avaliação está <strong>Publicada </strong> e por isso algumas funções não podem <strong>atualizada</strong> ou <strong>excluida</strong>
    </v-alert>
    <div
      v-if="exam"
      class="d-flex flex-column"
    >
      <div :class="exam.is_published ? 'order-3' : 'order-1'">
        <ExamQuestionGroups
          :exam="exam"
        />
      </div>
      <div class="order-2">
        <v-divider class="my-10" />
        <ExamTargets
          :exam="exam"
          :loading="loading"
          :is-published="exam.is_published"
        />
        <v-divider class="my-10" />
      </div>
      <div :class="exam.is_published ? 'order-1' : 'order-3'">
        <ExamApplications
          class="mt-5"
          :exam="exam"
        />
        <ExamExportImport
          class="mt-5"
          :exam="exam"
        />
      </div>
    </div>
  </ItemPage>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import ExamQuestionGroups from './components/ExamQuestionGroups.vue'
import ExamApplications from './components/ExamApplications.vue'
import ExamExportImport from './components/ExamExportImport.vue'
import utils from '@/api/utils.js'
import ExamTargets from './components/ExamTargets.vue'

export default {
  components: {
    ItemPage,
    ExamQuestionGroups,
    ExamApplications,
    ExamExportImport,
    ExamTargets
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      titlePage: 'Avaliação',
      targets: [],
      exam: null,
      loading: false
    }
  },
  computed: {
    id () {
      return this.$route.params.examId
    },
    questionsView () {
      return utils.checkPermissions('questions.view-any')
    },
    questionsCreate () {
      return utils.checkPermissions('questions.create')
    },
    questionsUpdate () {
      return !utils.checkPermissions('grade-level-groups.update-any')
    },
    questionsDelete () {
      return !utils.checkPermissions('grade-level-groups.delete')
    },

    actions () {
      return [
        {
          label: this.exam?.is_published ? 'despublicar avaliação' : 'Publicar avaliação',
          action: this.publish,
          icon: this.exam?.is_published ? 'mdi-close' : 'mdi-check',
          disabled: this.questionsUpdate ? this.questionsUpdate : this.loading
        }
      ]
    }
  },
  watch: {
  },
  async mounted () {
    await this.getExams()
  },
  methods: {
    async getExams () {
      this.loading = true
      try {
        this.exam = await this.$api.getExams(this.id)
        this.titlePage = this.exam.title + (this.exam.subtitle ? ' - ' + this.exam.subtitle : '')
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar obter avaliação.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },

    async publish () {
      this.loading = true
      try {
        if (this.exam.is_published) {
          await this.$api.unpublishExams(this.id)
          this.$store.dispatch('setSnackBar', { text: 'Avaliação despublicada com sucesso.' })
        } else {
          await this.$api.publishExams(this.id)
          this.$store.dispatch('setSnackBar', { text: 'Avaliação publicada com sucesso.' })
        }
        await this.getExams()
        this.loading = false
      } catch (e) {
        const error = e?.response?.data?.message
        if (error) {
          this.$store.dispatch('setSnackBar', { text: error, color: 'red' })
        } else {
          this.$store.dispatch('setSnackBar', { text: 'Erro ao tentar publicar avaliação.', color: 'red' })
        }
        this.loading = false
      }
    }
  }
}
</script>
